export default "__VITE_ASSET__CpB7lxiE__"